<template>
  <div class="introduction" style="min-width: 1900px">
    <div
      class="introduction_about scaleBanner"
      :style="'background-image: url(' + domList[0].url + ');'"
    >
      <div class="introduction_about_box">
        <div class="introduction_about_name moveTopTitle">
          {{ domList[0].val }}
        </div>
      </div>
      <div class="box"></div>
    </div>
    <div class="center_title">
      <img
        src="../../../static/newImg2/home.png"
        width="16px"
        @click="toPage('/')"
      />
      <span class="center_home"> > {{ domList[0].val }}</span>
    </div>
    <!-- 药材合集 -->
    <div class="Search moveTopNormal">
      <div style="display: flex">
        <div class="dom_pull_city">
          <el-select
            v-model="cityTab"
            @change="cityItem"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in cityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="dom_pull_m">
          <el-select
            v-model="valueTab"
            @change="changeItem"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in tabList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="display: flex">
        <input
          type="text"
          v-model="medicinalName"
          class="dom_input"
          placeholder="请输入您要搜索的药名"
        />
        <el-button @click="search" class="dom_btn_CK">查询</el-button>
      </div>
    </div>
    <div class="business_list">
      <div class="business_list_right">
        <div
          class="business_list_right_item moveTopNormal"
          v-for="item in medicineList"
          :key="item.name"
          @click="toDetails(item)"
        >
          <div class="business_list_right_item_img">
            <img
              :src="
                require('../../../static/image/' + item.medicineName + '.jpg')
              "
              width="100%"
            />
          </div>
          <div class="business_list_right_item_name">
            {{ item.medicineName }}
          </div>
          <div class="business_list_right_item_alias">
            别名：{{ item.medicineOtherName }}
          </div>
          <div class="business_list_right_item_area">
            产地：{{ item.medicineOriginPlace }}
          </div>
        </div>
      </div>
    </div>
    <div class="business_pagination">
      <el-pagination
        layout="prev, pager, next"
        :page-size="20"
        :current-page="query.page"
        :total="query.total"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  getAccessToken,
  getSignature,
  getintroducelist,
  getCompanyDetailById,
} from "@/api/index";
export default {
  name: "introduction",
  data() {
    return {
      medicinalName: null,
      introduction_bg: require("../../../static/image/introduction_bg1.png"),
      introduction_b1g: require("../../../static/image/bgimg.png"),
      introduction_b2g: require("../../../static/image/位图备份1111.png"),
      list: [],
      domList: [
        {
          id: 0,
          val: "药材合集",
          url: require("../../../static/v1.0/大药材.png"),
        },
      ],
      DomId: 0,
      DomVal: "药材合集",
      imgIndex: 0,
      showNumType: true,
      medicineList: [],
      query: {
        page: 1,
        size: 20,
      },
      tabIndex: null,
      cityTab: null,
      cityList: [
        {
          value: 1,
          label: "浙江省",
        },
      ],
      valueTab: null,
      tabList: [
        {
          value: 1,
          label: "关药",
        },
        {
          value: 2,
          label: "北药",
        },
        {
          value: 3,
          label: "怀药",
        },
        {
          value: 4,
          label: "维药",
        },
        {
          value: 5,
          label: "浙药",
        },
        {
          value: 6,
          label: "海药",
        },
        {
          value: 7,
          label: "南药",
        },
        {
          value: 8,
          label: "蒙药",
        },
        {
          value: 9,
          label: "川药",
        },
        {
          value: 10,
          label: "云药",
        },
        {
          value: 11,
          label: "贵药",
        },
        {
          value: 12,
          label: "广药",
        },
        {
          value: 13,
          label: "淮药",
        },
        {
          value: 14,
          label: "藏药",
        },
        {
          value: 15,
          label: "秦药",
        },
      ],
      companyItem: null,
    };
  },
  //   components: { dotMap },
  computed: {},
  created() {
    if (localStorage.getItem("pageNumber")) {
      this.query.page = Number(localStorage.getItem("pageNumber"));
      localStorage.removeItem("pageNumber");
    } else {
      this.query.page = 1;
    }
  },
  mounted() {
    let company;
    if (this.$route.query.companyId) {
      getCompanyDetailById(this.$route.query.companyId).then((res) => {
        company = res.data;
        this.$store.commit("setCompany", company);
        this.companyItem = company;
        window.addEventListener("popstate", this.handlePopState);
        setTimeout(() => {
          window.scroll(0, 0);
          localStorage.removeItem("zoneyuccId");
        }, 100);
        if (this.$route.query.id) {
          this.DomId = this.$route.query.id;
        }
        if (this.$route.query.type) {
          this.valueTab = Number(this.$route.query.type);
          this.changeItem(this.valueTab);
        } else {
          this.getList();
        }
        if (localStorage.getItem("zoneyuccId")) {
          this.DomId = localStorage.getItem("zoneyuccId");
        }
        this.getWXInfo();
        window.addEventListener("scroll", this.showNum);
        if (
          /Mobile|Android|iPhone|iPad|iPod|Windows Phone/i.test(
            navigator.userAgent
          )
        ) {
          document.getElementsByClassName("introduction")[0].style =
            "min-height: 2800px;";
        }
      });
    } else {
      company = this.$store.getters.getCompany;
      this.companyItem = company;
      window.addEventListener("popstate", this.handlePopState);
      setTimeout(() => {
        window.scroll(0, 0);
        localStorage.removeItem("zoneyuccId");
      }, 100);
      if (this.$route.query.id) {
        this.DomId = this.$route.query.id;
      }
      if (this.$route.query.type) {
        this.valueTab = Number(this.$route.query.type);
        this.changeItem(this.valueTab);
      } else {
        this.getList();
      }
      if (localStorage.getItem("zoneyuccId")) {
        this.DomId = localStorage.getItem("zoneyuccId");
      }
      this.getWXInfo();
      window.addEventListener("scroll", this.showNum);
      if (
        /Mobile|Android|iPhone|iPad|iPod|Windows Phone/i.test(
          navigator.userAgent
        )
      ) {
        document.getElementsByClassName("introduction")[0].style =
          "min-height: 2800px;";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.showNum);
    window.removeEventListener("popstate", this.handlePopState);
  },
  methods: {
    showNum() {
      if (window.scrollY > 300 && this.showNumType) {
        this.allCountUp();
      }
    },
    handlePopState(event) {},
    search() {
      if (!this.medicinalName) {
        this.getList();
        return;
      }
      axios
        .get(
          `https://t2.zoneyu.group/cms/api/app/medicine/list?pageNum=1&pageSize=20&medicineType=${
            this.tabIndex ? this.tabList[this.tabIndex - 1].label : ""
          }&medicineName=${this.medicinalName}`
        )
        .then((res) => {
          this.medicineList = res.data.data.list;
          this.query.total = res.data.data.total;
        });
    },
    allCountUp() {
      new this.$countUp("ZZMJ", 7944).start();
      new this.$countUp("XSDW", 20).start();
      new this.$countUp("GZRY", 3600).start();
      new this.$countUp("QDSJ", 2023).start();
      this.showNumType = false;
    },
    toPage(path) {
      this.$router.push({ path });
    },
    onType(val) {
      this.DomId = val.id;
      this.DomVal = val.val;
      document.getElementsByClassName("introduction_about")[0].className =
        "introduction_about";
      setTimeout(() => {
        document.getElementsByClassName("introduction_about")[0].className =
          "introduction_about scaleBanner";
      }, 50);
    },
    handleCurrentChange(e) {
      //   console.log(e);
      this.query.page = e;
      localStorage.setItem("pageNumber", this.query.page);
      this.getList(this.tabIndex);
      window.scroll(0, 0);
    },
    getWXInfo() {
      const that = this;
      getSignature({ pageUrl: window.location.href }).then((res) => {
        const timestamp = res.data.timestamp;
        const nonceStr = res.data.noncestr;
        const signature = res.data.signature;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: "wxad8dd02ae97d307f", // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          const obj = {
            title: "药材合集", // 分享标题
            desc: that.companyItem.companyDesc, // 分享描述
            link:
              window.location.href +
              "?companyId=" +
              that.companyItem.companyId +
              "&companyArr=" +
              JSON.stringify(that.$store.getters.getCompanyTier), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl:
              "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2024-10-09/0022e23746254f9eae6724ad475d29e5.png", // 分享图标
          };
          wx.updateAppMessageShareData(obj);
          wx.updateTimelineShareData(obj);
        });
      });
    },
    getList(index) {
      console.log(index);
      axios
        .get(
          `https://t2.zoneyu.group/cms/api/app/medicine/list?pageNum=${
            this.query.page
          }&pageSize=20&medicineType=${
            index && this.tabList[this.tabIndex - 1]
              ? this.tabList[this.tabIndex - 1].label
              : ""
          }&medicineName=`
        )
        .then(async (res) => {
          this.medicineList = [];
          this.medicineList = res.data.data.list;
          this.query.total = res.data.data.total;
          setTimeout(() => {
            const list = document.querySelectorAll(".business_list_right_item");
            list.forEach((e) => {
              e.classList.add("moveTopAnimation");
            });
          }, 500);
          if (this.changePage) {
            this.$nextTick(() => {
              const arr = document.querySelectorAll(
                ".business_list_right_item"
              );
              arr.forEach((el) => {
                el.className = "business_list_right_item";
              });
            });
          }
        });
    },
    cityItem(e) {
      if (!e) {
        this.tabIndex = "";
        this.getList();
        return;
      }
      this.valueTab = null;
      this.medicinalName = null;
      const list = [
        {
          id: 520,
          medicineDetail:
            '<div class="content pt30"> \n <p></p>\n <h3>概述：</h3>\n <p></p> \n <p>白术为菊科植物白术Atractylodes macrocephala Koidz.的干燥根茎。冬季下部叶枯黄、上部叶变脆时采挖，除去泥沙，烘干或晒干，再除去须根。主产于浙江、安徽，以浙江产量大。</p> \n <h3>来源</h3> \n <p>本品为菊科植物白术<em>Atractylodes macrocephala</em>&nbsp;Koidz.的干燥根茎。（《中国药典2015》）</p> \n <h3>分布产地</h3> \n <p>主产于浙江、安徽，以浙江产量最大。</p> \n <h3>入药部位</h3> \n <p>根及根茎</p> \n <h3>采收加工</h3> \n <p>冬季下部叶枯黄、上部叶变脆时采挖，除去泥沙，烘干或晒干，再除去须根。（《中国药典2015》）</p> \n <h3>药材性状</h3> \n <p>本品为不规则的肥厚团块，长3-13cm，直径1.5-7cm。表面莰黄色或灰棕色，有瘤状突起及断续的纵皱和沟纹，并有须根痕，顶端有残留茎基和芽痕。质坚硬不易折断，断面不平坦，黄白色至淡棕色，有棕黄色的点状油室散在；烘干者断面角质样，色较深或有裂隙。气清香，味甘、微辛，嚼之略带黏性。（《中国药典2015》）</p> \n <h3>性味归经</h3> \n <p>苦、甘，温。归脾、胃经。（《中国药典2015》）</p> \n <h3>药材功效</h3> \n <p>健脾益气，燥湿利水，止汗，安胎。（《中国药典2015》）</p> \n <h3>药材主治</h3> \n <p>用于脾虚食少，腹胀泄泻，痰饮眩悸，水肿，自汗，胎动不安。（《中国药典2015》）</p> \n <h3>用法用量</h3> \n <p>6-12g。（《中国药典2015》）</p> \n <h3>用药禁忌</h3> \n <p>阴虚津亏者慎服。（《中药大辞典》）</p> \n <h3>贮藏保存</h3> \n <p>置阴凉干燥处，防蛀。（《中国药典2015》）</p> \n <h3>药材鉴别</h3> \n <p>显微鉴别：<br> 本品粉末淡黄棕色。草酸钙针晶细小，长10-32μm，存在于薄壁细胞中，少数针晶直径至4μm。纤维黄色，大多成束，长梭形，直径约至40μm，壁甚厚，木化，孔沟明显。石细胞淡黄色，类圆形、多角形、长方形或少数纺锤形，直径37-64μm。薄壁细胞含菊糖，表面显放射状纹理。导管分子短小，为网纹导管及具缘纹孔导管，直径至48μm。<br> 理化鉴别：<br> 取本品粉末0.5g，加正己烷2ml，超声处理15分钟，滤过，取滤液作为供试品溶液。另取白术对照药材0.5g，同法制成对照药材溶液。照薄层色谱法（通则0502）试验，吸取上述新制备的两种溶液各10μl，分别点于同一硅胶G薄层板上，以石油醚（60-90℃）乙酸乙酯（50：1）为展开剂，展开，取出，晾干，喷以5%香草醛硫酸溶液，加热至斑点显色清晰。供试品色谱中，在与对照药材色谱相应的位置上，显相同颜色的斑点，并应显有一桃红色主斑点（苍术酮）。（《中国药典2015》）</p> \n <h3>中药配伍</h3> \n <p>1.治虚弱枯瘦，食而不化：于术（酒浸，九蒸九晒）一斤，菟丝子（酒煮吐丝，晒干）一斤，共为末，蜜丸，梧子大。每服二、三钱。（《纲目拾遗》）<br> 2.治脾虚胀满：白术二两，橘皮四两。为末，洒糊丸，梧子大。每食前木香汤送下三十丸。（《全生指迷方》宽中丸）<br> 3.治痞，消食强胃：枳实（麸炒黄色）一两，白术二两。上为极细末，荷叶裹烧饭为丸，如绿豆一倍大。每服五十丸，白汤下，不拘时候，量所伤多少，加减服之。（《兰室秘藏》积术丸）<br> 4.服食滋补，止久泄痢：上好白术十两，切片，入瓦锅内，水淹过二寸，文武火煎至一半，倾汁入器内，以渣再煎，如此三次，乃取前后汁同熬成膏，入器中一夜，倾去上面清水，收之。每服二、三匙，蜜汤调下。（《千金良方》白术膏）<br> 5.治脾虚泄泻：白术一两，芍药半两（冬月不用芍药，加肉豆蔻，泄者炒）。上为末，粥丸。（《丹溪心法》白术丸）<br> 6.治小儿久患泄泻，脾虚不进饮食，或食讫仍前泻下，米谷不化：白术一分（米泔浸一时，切，焙干），半夏一钱半（浸洗七次），丁香半钱（炒）。上为细末，生姜自然汁糊丸，黍米大。每半岁儿三丸，三五岁儿五、七丸，淡生姜汤下，早晚各一。（《小儿卫生总微论方》温白丸）<br> 7.治湿泻暑泻：白术、车前子等分，炒为末，白汤下二、三钱。（《简便单方》）<br> 8.治肠风痔漏、脱肛泻血、面色萎黄，积年久不瘥：白术一斤（糯米泔浸三日，细研锉，炒焦为末），干地黄半斤（净洗，用碗盛于甑上蒸烂细研）。上相和，如硬，滴酒少许，众手丸梧桐子大，焙干。每服十五丸，空心粥饮下，加至二十丸。（《普济方》香术丸）<br> 9.治心下坚，大如盘，边如旋盘，水饮所作：枳实七枚，白术二两。上二味，以水五升，煮取三升，分温三服，腹中耍即当散也。（《金匮要赂）枳术汤）<br> 10.治伤寒八九日，风湿相搏，身体疼烦，不能自转侧，不呕不渴，脉浮虚而涩，大便坚，小便自利者：白术二两，附子一枚半（炮去皮），甘草一两（炙），生姜一两半（切），大枣六枚。上五味，以水三升，煮取一升去滓，分温三服，一服觉身痹半日许，再服。三服都尽，其人如冒状，勿怪，即是术、附并走皮中，逐水气未得除故耳。（《金匮要略》白术附子汤）<br> 11.治中湿，口噤，不知人：白术半两，酒三盏。煎一盏，顿服；不能饮酒，以水代之。日三，夜一。（《三因方》白术酒）<br> 12.治忽头眩运，经久不差，四体渐羸，食无味，好食黄土：白术三斤，曲三斤。上二味搀筛酒和，并手捻丸如梧子，暴干。饮服二十枚，日三。忌桃、李、雀肉等。（《外台》）<br> 13.治风虚，头重眩，苦极，不知食味。暖肌，补中，益精气：白术二两，附子一枚半（炮去皮），甘草一两（炙）。上三味，锉，每五钱匕，姜五片，枣一枚，水盏半，煎七分，去滓，温服。（《近效方》术附汤）<br> 14.治自汗不止：白术末，饮服方寸匕，日二服。（《千金方》）<br> 15.治盗汗：白术四两，分作四份，一份用黄芪同炒，一份用石斛同炒，一份用牡蛎同炒，一份用麸皮同炒。上各微炒黄色，去余药。只用白术，研细。每服二钱，粟米汤调下，尽四两。（《丹溪心法》）<br> 16.治老小虚汗：白术五钱，小麦一撮，水煮干，去麦为末，用黄芪汤下一钱。（《全幼心鉴》）<br> 17.治产后呕逆不食：白术五钱，姜六钱。水煎，徐徐温服。（《妇人良方》）<br> 18.治妇人血虚肌热，或脾虚蒸热，或内热寒热：白术、白茯苓、白芍药（炒）各一钱，甘草（炒）五分，姜、枣，水煎。（《妇人良方》乞力伽散）<br> 19.治三日疟：九制於术一斤，广皮八两。熬膏，用饴糖四两收。（《古今良方》）<br> 20.治四日两头疟，一、二年至三、四年不愈者，或愈而复发，连绵不巳者：於术一两，老姜一两。水煎，发日五更温服，重者二服。（《纲目拾遗》）<br> 21.治牙齿逐日长，渐渐胀，开口难为饮食，盖髓溢所致：只服白术愈。（《夏子益治奇疾方》）<br> 22.治儿童流涎：生白术捣碎，加水和食糖，放锅上蒸汁，分次口服，每天用三钱。（《江苏中医》）</p> \n <h3>中药炮制</h3> \n <p>白术：除去杂质，洗净，润透，切厚片，干燥。<br> 麸炒白术：将蜜炙麸皮撒入热锅内，待冒烟时加入白术片，炒至黄棕色、逸出焦香气，取出，筛去蜜炙麸皮。每100kg白术片，用蜜炙麸皮10kg。（《中国药典2015》）</p> \n <h3>道地性</h3> \n <p>淮药、 浙药</p> \n <h3>相关论述</h3> \n <p>1.《汤液本草》：《本草》在术条下无苍、白之名。近多用白术治皮间风，止汗消痞，补胃和中，利腰脐间血，通水道，上而皮毛，中而心胃，下而腰脐，在气主气，在血主血。<br> 2.《本草会编》：脾恶湿，湿胜则气不得施化，津何由生？故曰：膀胱者，津液之府，气化则能出焉。用白术以除其湿，则气得周流而津液生矣。<br> 3.《本草经疏》：术，其气芳烈，其味甘浓，其性纯阳，为除风痹之上药，安脾胃之神品。《本经》主风寒湿痹、死肌、痉、疸者，正以风寒湿三者合而成痹，痹者，拘挛而痛者是也。《经》曰，地之湿气，感则害人皮肉筋骨。死肌者，湿毒侵肌肉也。痉者，风寒乘虚客于肝、脾、肾所致也。疸者，脾胃虚而湿热瘀滞也。如上诸病，莫不由风寒湿而成，术有除此三邪之功，故能祛其所致之疾也。止汗、除热、消食者，湿热盛则自汗，湿邪客则发热，湿去而脾胃燥，燥则食自消，汗自止，热自除也。又主大风在身面者，术气芳烈而悍，纯阳之物也，风为阳邪，发于阳部，故主之也。风眩头痛目泪出者，阳虚则风客之而眩，痰厥则头痛，风热壅则目泪出也。消痰水，逐皮间风水、结肿，除心下急痛，及霍乱吐下不止者，湿客于胃则滞而生痰，客于脾则生水，脾虚湿胜，则为水肿，湿客中焦则心下急满，脾胃俱虚，则中焦不治，而湿邪客之，则为霍乱吐下不止也。利腰脐间血者，血属阴，湿为阴邪，下流客之，使腰脐血滞而不得通利，湿去则诸证无不愈矣。益津液，暖胃消谷嗜食者，湿去则胃强，而津液自生，寒湿散则胃自暖，邪去而脾胃健，则消谷而嗜食矣。术，《本经》无分别，陶弘景有赤、白二种，近世乃有苍、白之分，其用较殊，要之俱为阳草，故祛邪之功胜，而益阴之效亏，药性偏长，物无兼力，此天地生物自然之道也。凡病属阴虚，血少，精不足，内热骨蒸，日干唇燥，咳嗽吐痰，吐血，鼻衄、齿衄，咽塞便秘滞下者，法咸忌之。术燥肾而闭气，肝肾有动气者勿服。《刘涓子痈疽论》云：溃疡忌白术，以其燥肾而闭气，故反生脓作痛也。凡脏皆属阴，世人但知术能健脾，此盖指脾为正邪所干，术能燥湿，湿去则脾健，故曰补也。宁知脾虚而无湿邪者，用之反致燥竭脾家津液，是损脾阴也。何补之足云？此最易误，故特表而出之。<br> 4.《本草汇言》：白术，乃扶植脾胃，散湿除痹，消食除痞之要药也。脾虚不健，术能补之，胃虚不纳，术能助之。是故劳力内伤，四肢困倦，饮食不纳，此中气不足之证也；痼冷虚寒，泄泻下利，滑脱不禁，此脾阳乘陷之证也；或久疟经年不愈，或久痢累月不除，此胃虚失治，脾虚下脱之证也；或痰涎呕吐，眩晕昏眩，或腹满肢肿，面色痿黄，此胃虚不运，脾虚蕴湿之证也；以上诸疾，用白术总能治之。又如血虚而漏下不止，白术可以统血而收阴；阳虚而汗液不收，白术可以回阳而敛汗。大抵此剂能健脾和胃，运气利血。兼参、耆而补肺，兼杞、地而补肾，兼归、芍而补肝，兼龙眼、枣仁而补心，兼芩、连而泻胃火，兼橘、半而醒脾土，兼苍、朴可以燥湿和脾，兼天、麦亦能养肺生金，兼杜仲、木瓜，治老人之脚弱，兼麦芽、枳、朴，治童幼之疳症。黄芩共之，能安胎调气。枳实共之，能消痞除膨。君参、苓、藿、半，定胃寒之虚呕。君归、芎、芍、地，养血弱而调经。温中之剂无白术，愈而复发。溃疡之证用白术，可以托脓。<br> 5.《本草通玄》：白术，补脾胃之药，更无出其右者。土旺则能健运，故不能食者，食停滞者，有痞积者，皆用之也。土旺则能胜湿，故患痰饮者，肿满者，湿痹者，皆赖之也。土旺则清气善升，而精微上奉，浊气善降，而糟粕下输，故吐泻者，不可阙也。《别录》以为利腰脐间血者，因脾胃统摄一身之血，而腰脐乃其分野，借其养正之功，而瘀血不敢稽留矣。张元素谓其生津止渴者，湿去而气得周流，而津液生矣。谓其消痰者，脾无湿则痰自不生也。安胎者，除胃中热也。<br> 6.《本草崇原》：凡欲补脾，则用白术，凡欲运脾，则用苍术，欲补运相兼，则相兼而用，如补多运少，则白术多而苍术少，运多补少，则苍术多而白术少，品虽有二，实则一也。《本经》未分苍、白，而仲祖《伤寒》方中，皆用白术，《金匮》方中，又用赤术，至陶弘景《别录》则分为二，须知赤、白之分，始于仲祖，非弘景始分之也。赤术，即是苍术，其功用与白术略同，故仍以《本经》术之主治为本。但白术味甘，苍术兼苦，白术止汗，苍术发汗，故止汗二字，节去不录。后人谓苍术之味苦，其实苍术之味甘而微苦。<br> 7.《本经逢原》：白术，生用有除湿益燥，消痰利水，治风寒湿痹，死肌痉疸，散腰脐间血，及冲脉为病，逆气里急之功；制熟则有和中补气，止渴生津，止汗除热，进饮食，安胎之效。<br> 8.《长沙药解》：白术，性颇壅滞，宜辅之以疏利之品，肺、胃不开，加生姜、半夏以驱浊，肝、脾不达，加砂仁、桂枝以宣郁，令其旋补而旋行，则美善而无弊矣。<br> 9.《本草求真》：白术缘何专补脾气？盖以脾苦湿，急食苦以燥之，脾欲缓，急食甘以缓之；白术味苦而甘，既能燥湿实脾，复能缓脾生津。且其性最温，服则能以健食消谷，为脾脏补气第一要药也。书言无汗能发，有汗能收，通溺止泄，消痰治肿，止热化癖，安胎止呕，功效甚多，总因脾湿则汗不止，脾健则汗易发，凡水湿诸邪，靡不因其脾健而自除，吐泻及胎不安，亦靡不因其脾健而悉平矣。故同枳实则能治痞，同黄芩则能安胎，同泽泻则能利水，同干姜、桂心则能消饮去癖，同地黄为丸，则能以治血泻萎黄，同半夏、丁香、姜汁，则可以治小儿久泻，同牡蛎、石斛、麦麸，则可以治脾虚、盗汗。然血燥无湿，肾间动气筑筑，燥渴便闭者忌服。谓其燥肾闭气，则其气益筑。又寒湿过甚，水满中宫者亦忌，谓其水气未决，苦不胜水，甘徒滋壅，必待肾阳培补，水气渐消，肾气安位，术始可投，此又不得不变换于中也。盖补脾之药不一，白术专补脾阳，生则较熟性更鲜，补不腻滞，能治风寒湿痹，及散腰脐间血，并冲脉为病，逆气里急之功，非若山药止补脾脏之阴，甘草止缓脾中之气，而不散于上下，俾血可生，燥症全无。苍术气味过烈，散多于补，人参一味冲和，燥气悉化，补脾而更补肺，所当分别而异视者也。<br> 10.《本经疏证》：风寒湿痹、死肌、痉、疸，不得尽谓脾病，而以术为主剂者，则以湿为脾所主，湿能为患，固属脾气不治，一也；脾主肌肉，介在皮毛筋骨中，痹与痉，病在肌肉内，死肌及疸，病在肌肉外，旁病则当取中，二也；筋骨皮毛，均非驻湿之所，惟肌肉间为可驻湿，三也。知此，则凡痹、死肌、痉、疸之系乎风寒湿者，皆术主之矣。白术之效，于风胜湿者为最宜，寒胜者为差减。何以知之？盖风胜必烦，湿胜必重，检《金匮要略》中治痹诸方，其用术者，非兼烦必兼重，虽然，谓术功擅于风与湿则可，谓于寒有所忌则不可，《伤寒》少阴篇附子汤，治身体疼，手足寒，骨节痛，不烦不重，亦用白术。盖湿流关节，云骨节痛，则未有不兼湿者，矧风湿二者，必挟寒始成痹，不然则否，《素问》之旨可验也。白术治眩，非治眩也，治痰饮与水耳。有痰与水，何以能使人眩？盖眩者神之动，神依于心，心恶水，水盛则心神摇曳为眩，譬如人在舟中，能发眩也，虽然人在舟中，未必尽眩，不在舟中，未必不眩。所以眩证不必尽用术，用术之饮证水证，亦未必尽眩，夫亦各因乎其人耳。《伤寒论》、《金匮要略》其有饮有水，不眩而用术者，则指不胜屈，其有饮眩而不用术者亦多，则系证与术有忌耳，即如卒呕吐，心下痞，膈间有水，眩悸者，小半夏加茯苓汤主之，则以心下痞，故正与理中丸下注云腹满者去术，同一理也。世之人动辄称白术、黄芩安胎圣药，而疏其义者，不过谓白术健脾，黄芩泄热，殊不知健脾泄热之物，岂特白术、黄芩。夫妇人之病，多半涉血，矧妊娠尤赖血气之调，方得母子均安。初妊之时，胎元未旺，吸血不多，则下焦血旺，致气反上逆，是为恶阻。恶阻则中焦之气不变赤而为水，是白术所必需矣。血盛能致气盛，气盛能生火，黄芩泄气分之火而不伤血者也；厥后胎气日充，吸血渐多，血自盘旋而下，气亦随之盘旋于下，胎之所吸，乃血之精者。而其馀与气相搏，能仍化为水，阻于腰脐之间，故妊娠至五、六月时，多有子肿之证，是白术又为必需之剂，而无所事黄芩于其间，《别录》所谓利腰脐间血者此也。考仲景书于妇人妊娠篇之白术散，与芎藭同用，当归芍药散、当归散，与芍药、当归、芎藭同用者，不可知其为除水气而利腰脐间血哉。总之，血分之源不清，则血气不能和，而附血之湿，血盛之火，皆为胎前所有之常患，故出此不必甚为别择之常方，学者尤当会意而用之也。<br> 11.《医学衷中参西录》：白术，性温而燥，气不香窜，味苦微甘微辛，善健脾胃，消痰水，止泄泻，治脾虚作胀，脾湿作渴，脾弱四肢运动无力，甚或作疼。与凉润药同用，又善补肺；与升散药同用，又善调肝；与镇安药同用，又善养心；与滋阴药同用，又善补肾。为其具土德之全，为后天资生之要药，故能于金、木、水、火四脏，皆能有所补益也。<br> 12.《本草正义》：《本草经》及《别录》皆称术而无苍、白之分，陶氏弘景及宋之苏颂，皆言术以茅山为胜，似今之所谓茅山苍术，亦即古之所谓术也。然弘景又别有赤术之名，谓其苦而多膏，又似梁时已有苍术一种。今按《本经》主治，详其功用，颇似今之茅术。惟白术健脾化湿，其力亦同。至《名医别录》又言味苦甘，增一甘字，则明是白术。李濒湖以《本经》、《别录》之文，两系白术、苍术二条，而张隐庵因之，真骈拇矣。术之功用，自唐以前，止言其燥湿逐水，所谓暖胃消食，亦燥能健脾醒胃也。盖其气甚烈，故能振动脾阳，而又疏通经络，然又最富脂膏，故虽苦温能燥，而亦滋津液，且以气胜者，流行迅利，本能致津液通气也。唐、宋以后，皆以为补益脾胃，其旨即从此出。颐谓白术、苍术在古不分，而今已各别，则凡古人所称燥湿逐水之用，今必以茅山苍术当之，其补益脾胃，则宜用白术。盖今之所谓冬白术者，质润而气香，健运脾阳，滋养胃阴之力不小，且其气既盛，不致呆守满中，允为健脾益胃之专剂矣。东垣谓白术主安胎，盖谓妊娠养胎，依赖脾土，术能健脾故耳。丹溪谓白术无汗能发，有汗能止。颐按白术补中，虽以气胜，不可谓其发汗。惟苍术则辛烈开腠，能发湿家之汗耳。缪仲醇引《刘涓子痈疽论》谓溃疡忌白术，以其燥肾闭气，故能生脓作痛，张石顽亦采其说，不知术能补益，溃疡毒盛，诚非所宜，若溃后元虚，非补脾胃，何以收效？参、地、术、芪，皆是补虚要药，岂可不论虚实，而一概抹煞之耶？缪氏又谓术以气胜，除邪之功巨，补阴之效亏，凡阴虚血少燥渴及精不足，便闭滞下者忌之。缪氏之意，盖谓其气味燥烈，故有耗阴燥精等弊。愚谓术本多脂，万无伤阴之虑。</p> \n</div>',
          medicineEffect: "补虚药",
          medicineFamilies: "菊科",
          medicineName: "白术",
          medicineOfficialName: "ATRACTΜLODIS MACROCEPHALAE RHIZOMA",
          medicineOriginPlace: "浙江、安徽",
          medicineOtherName: "术、山芥、天蓟",
          medicineType: "淮药、 浙药",
        },
        {
          id: 399,
          medicineDetail:
            '<div class="content pt30"> \n <p></p>\n <h3>概述：</h3>\n <p></p> \n <p>黄精为百合科植物滇黄精polygonatum kingianum Coll. et Hemsl.、黄精Polygonatum sibiricum Delar. ex Redoute或多花黄精Polygonatum cyrtonema Hua的干燥根茎。按形状不同，习称“大黄精”、“鸡头黄精”、“姜形黄精”。春、秋二季采挖，除去须根，洗净，置沸水中略烫或蒸至透心，干燥。黄精主产于河北、内蒙古、陕西、辽宁、吉林、河南、山西等地；多花黄精主产于浙江、安徽、湖南、贵州等地。滇黄精主产于广西、云南、贵州等地。</p> \n <h3>来源</h3> \n <p>本品为百合科植物滇黄精<em>polygonatum kingianum</em>&nbsp;Coll. et Hemsl.、黄精<em>Polygonatum sibiricum</em>&nbsp;Delar. ex Redoute或多花黄精<em>Polygonatum cyrtonema</em>&nbsp;Hua的干燥根茎。按形状不同，习称“大黄精”、“鸡头黄精”、“姜形黄精”。（《中国药典2015》）</p> \n <p>除上述3种主流品种外，各地作黄精药用的主要还有：①轮叶黄精<em>Polygonatum verticillatum</em>&nbsp;(L.) All.，分布于山西、陕西、甘肃、青海、四川、云南、西藏。②卷叶黄精<em>Polygonatum cirrhifolium</em>&nbsp;(Wall.) Royle，分布于陕西、宁夏、甘肃、青海、四川、云南、西藏。③互卷黄精<em>Polygonatum alternicirrhosum</em>&nbsp;Hand.-Mzt.，分布于四川。④热河黄精<em>Polygonatum macropodium</em>&nbsp;Turcz.，分布于辽宁、河北、山西、山东。⑤长梗黄精<em>Polygonatum filipes</em>&nbsp;Merr.，分布于长江以南地区。⑥对叶黄精<em>Polygonatum cathcartii</em>&nbsp;Baker，分布于四川、云南和西藏。其中轮叶黄精、卷叶黄精味苦的品种不能作黄精用。（《中华本草》）</p> \n <h3>分布产地</h3> \n <p>黄精主产于河北、内蒙古、陕西、辽宁、吉林、河南、山西等地；多花黄精主产于浙江、安徽、湖南、贵州等地。滇黄精主产于广西、云南、贵州等地。</p> \n <h3>入药部位</h3> \n <p>根及根茎</p> \n <h3>采收加工</h3> \n <p>春、秋二季采挖，除去须根，洗净，置沸水中略烫或蒸至透心，干燥。（《中国药典2015》）</p> \n <h3>药材性状</h3> \n <p>大黄精：呈肥厚肉质的结节块状，结节长可达10cm以上，宽3-6cm，厚2-3cm。表面淡黄色至黄棕色，具环节，有皱纹及须根痕，结节上侧茎痕呈圆盘状，圆周凹入，中部突出。质硬而韧，不易折断，断面角质，淡黄色至黄棕色。气微，味甜，嚼之有黏性。</p> \n <p>鸡头黄精：呈结节状弯柱形，长3-10cm，直径0.5-1.5cm。结节长2-4cm，略呈圆锥形，常有分枝。表面黄白色或灰黄色，半透明，有纵皱纹，茎痕圆形，直径5-8mm。</p> \n <p>姜形黄精：呈长条结节块状，长短不等，常数个块状结节相连。表面灰黄色或黄褐色，粗糙，结节上侧有突出的圆盘状茎痕，直径0.8-1.5cm。</p> \n <p>味苦者不可药用。（《中国药典2015》）</p> \n <h3>性味归经</h3> \n <p>甘，平。归脾、肺、肾经。（《中国药典2015》）</p> \n <h3>药材功效</h3> \n <p>补气养阴，健脾，润肺，益肾。（《中国药典2015》）</p> \n <h3>药材主治</h3> \n <p>用于脾胃气虚，体倦乏力，胃阴不足，口干食少，肺虚燥咳，劳嗽咳血，精血不足，腰膝酸软，须发早白，内热消渴。（《中国药典2015》）</p> \n <h3>用法用量</h3> \n <p>9-15g。（《中国药典2015》）</p> \n <h3>用药禁忌</h3> \n <p>中寒泄泻，痰湿痞满气滞者禁服。（《中药大辞典》）</p> \n <h3>贮藏保存</h3> \n <p>置通风干燥处，防霉，防蛀。（《中国药典2015》）</p> \n <h3>药材鉴别</h3> \n <p>显微鉴别：</p> \n <p>本品横切面：</p> \n <p>大黄精：表皮细胞外壁较厚。薄壁组织间散有多数大的黏液细胞，内含草酸钙针晶束。维管束散列，大多为周木型。</p> \n <p>鸡头黄精、姜形黄精：维管束多为外韧型。</p> \n <p>理化鉴别：</p> \n <p>取本品粉末1g，加70%乙醇20ml，加热回流1小时，抽滤，滤液蒸干，残渣加水10ml使溶解，加正丁醇振摇提取2次，每次20ml，合并正丁醇液，蒸干，残渣加甲醇1ml使溶解，作为供试品溶液。另取黄精对照药材1g，同法制成对照药材溶液。照薄层色谱法（通则0502）试验，吸取上述两种溶液各10μl，分别点于同一硅胶G薄层板上，以石油醚（60-90℃）—乙酸乙酯—甲酸（5：2：0.1）为展开剂，展开，取出，晾干，喷以5%香草醛硫酸溶液，在105℃加热至斑点显色清晰。供试品色谱中，在与对照药材色谱相应的位置上，显相同颜色的斑点。（《中国药典2015》）</p> \n <h3>中药配伍</h3> \n <p>①壮筋骨，益精髓，变白发：黄精、苍术各四斤，枸杞根、柏叶各五斤，天门冬三斤。煮汁一石，同曲十斤，糯米一石，如常酿酒饮。（《纲目》）</p> \n <p>②补精气：枸杞子（冬采者佳），黄精等分。为细末，二味相和，捣成块，捏作饼子，干复捣为末，炼蜜为丸，如梧桐子大。每服五十丸，空心温水送下。（《奇效良方》枸杞丸）</p> \n <p>③治脾胃虚弱，体倦无力：黄精、党参、淮山药各一两，蒸鸡食。（《湖南农村常用中草药手册》）</p> \n <p>④治肺劳咳血，赤白带：鲜黄精根头二两，冰糖一两，开水炖服。（《闽东本草》）</p> \n <p>⑤治肺结核，病后体虚：黄精五钱至一两。水煎服或炖猪肉食。（《湖南农村常用中草药手册》）</p> \n <p>⑥治小儿下肢痿软：黄精一两，冬蜜一两。开水炖服。（《闽东本草》）</p> \n <p>⑦治胃热口渴：黄精六钱，熟地、山药各五钱，天花粉，麦门冬各四钱。水煎服。（《山东中草药手册》）</p> \n <p>⑧治眼，补肝气，明目：蔓菁子一斤（以水淘净），黄精二斤（和蔓菁子水蒸九次，曝干）。上药，捣细罗为散。每服，空心以粥饮调下二钱，日午晚食后。以温水再调服。（《圣惠方》蔓菁子散）</p> \n <p>⑨治荣气不清，久风入脉，因而成癞，鼻坏色败，皮肤痒溃：黄精根（去皮洗净）二斤。日中曝令软，纳粟米饭甑中同蒸之，二斗米熟为度，不拘时服。（《圣济总录》）</p> \n <p>⑩治蛲虫病：黄精八钱，加冰糖二两，炖服。（《福建中医药》）</p> \n <h3>中药炮制</h3> \n <p>黄精：除去杂质，洗净，略润，切厚片，干燥。<br> 酒黄精：取净黄精，照酒炖法或酒蒸法（通则0213）炖透或蒸透，稍晾，切厚片，干燥。每100kg黄精，用黄酒20kg。（《中国药典2015》）</p> \n <h3>毒性</h3> \n <p>将生黄精及清蒸品的水提醇沉液按每24h450g（相当于原生药）/kg剂量给小鼠灌服，结果，生品组小鼠全部死亡，而炮制组小鼠无死亡，均活动正常，说明黄精炮制后毒性明显降低。（《中药大辞典》）</p> \n <h3>道地性</h3> \n <p>关药、 北药、 南药、 云药、 贵药</p> \n <h3>相关论述</h3> \n <p>1.《本经逢原》：黄精，宽中益气，使五藏调和，肌肉充盛，骨髓强坚，皆是补阴之功。</p> \n <p>2.《本草便读》：黄精，为滋腻之品，久服令人不饥，若脾虚有湿者，不宜服之，恐其腻膈也。此药味甘如饴，性平质润，为补养脾阴之正品。</p> \n</div>',
          medicineEffect: "补虚药",
          medicineFamilies: "百合科",
          medicineName: "黄精",
          medicineOfficialName: "POLYGONATI RHIZOMA",
          medicineOriginPlace: "河北、内蒙古、陕西、辽宁、吉林、河南、山西等地",
          medicineOtherName: "菟竹、鹿竹、重楼",
          medicineType: "关药、 北药、 南药、 云药、 贵药",
        },
      ];
      this.medicineList = list;
      this.query.total = 1;

      window.scroll(0, 0);
    },
    async changeItem(index) {
      this.cityTab = null;
      this.medicinalName = null;
      this.$set(this.query, "page", 1);
      this.tabIndex = index;
      this.getList(1);
      window.scroll(0, 0);
    },
    toDetails(item) {
      this.$router.push({
        path: "/medicineDetails",
        query: {
          id: item.id,
          tabIndex: this.tabIndex,
          cityTab: this.cityTab,
          valueTab: this.valueTab,
        },
      });
    },
    // getList() {
    //   axios
    //     .get(`https://t2.zoneyu.group/cms/api/app/introduce/list`)
    //     .then(async (res) => {
    //       //   this.list = res.data.data.list;
    //       this.medicineList = res.data.data.list;
    //     });
    // },
  },
  watch: {
    $route() {
      window.scroll(0, 0);
      this.query.page = 1;
      if (this.$route.query.type) {
        this.valueTab = Number(this.$route.query.type);
        this.changeItem(this.valueTab);
      } else {
        this.getList();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.introduction {
  overflow: hidden;
}

.introduction_bg {
  background: #f7f7f7;

  img {
    width: 100%;
  }
}

.introduction_about {
  width: 100%;
  height: 560px;
  background-size: cover;
  background-repeat: no-repeat;

  .introduction_about_bg {
    width: 1280px;
    margin: 0 auto;
    text-align: center;

    .introduction_about_title_zn {
      font-size: 20px;
      color: #1d1b19;
      font-style: normal;
    }

    .introduction_about_title_en {
      font-size: 20px;
      color: rgba(29, 27, 25, 0.44);
      font-style: normal;
    }

    .introduction_about_title_line {
      width: 323px;
      height: 1px;
      background: #efefef;
      margin: 16px auto 50px auto;
    }
  }

  .introduction_about_img {
    display: flex;
    margin: 0 auto;
    justify-content: center;

    img {
      width: 880px;
      height: 440px;
    }
  }

  .introduction_about_box {
    position: relative;
    width: 100%;
    height: 560px;
  }

  .box {
    position: absolute;
    top: 493px;
    left: 50%;
    transform: translateX(-50%);
  }

  .introduction_about_domList {
    width: 89px;
  }

  .introduction_about_item {
    display: flex;
    width: 824px;
    height: 67px;
    justify-content: space-between;

    div {
      // flex: 1;
      text-align: center;
    }

    .clsa {
      color: #fff !important;
      opacity: 1 !important;
      font-weight: bold;
    }

    .introduction_about_item_val {
      color: #fff;
      opacity: 0.5;
      cursor: pointer;
      height: 66px;
      font-size: 18px;
      line-height: 30px;
    }

    .hengang {
      width: 89px;
      height: 4px;
      background: #fff;
      position: absolute;
      bottom: 0;
      // transform: translateX(25%);
    }
  }

  .introduction_about_name {
    font-weight: bold;
    font-size: 56px;
    color: #ffffff;
    text-align: center;
    letter-spacing: 1px;
    font-family: 楷体;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .introduction_about_content {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    font-weight: 400;
    color: #000;
    line-height: 35px;
    letter-spacing: 2px;
    font-family: 宋体;
    text-align: center;
  }

  .introduction_about_detail {
    cursor: pointer;
    padding-bottom: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 21px;
    background: linear-gradient(180deg, #8eb368 0%, #608640 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.center_title {
  width: 1600px;
  margin: 0 auto;
  margin-top: 54px;
  z-index: 9;
  position: relative;

  & > img {
    cursor: pointer;
  }

  .center_home {
    font-weight: 400;
    font-size: 16px;
    color: #1d1b19;
    vertical-align: top;
    cursor: pointer;
  }
}

.Search {
  display: flex;
  width: 1350px;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 50px;

  .dom_pull_city {
    position: relative;
    width: 166px;
    height: 40px;
    background: #f6f6f6;
    border-radius: 7px;
  }

  .dom_pull_m {
    width: 166px;
    height: 40px;
    position: relative;
    background: #f6f6f6;
    border-radius: 7px;
    margin-left: 20px;
  }

  .dom_btn_CK {
    width: 160px;
    height: 40px;
    background: #128d4a;
    border-radius: 8px;
    margin-left: 20px;
    font-weight: 500;
    font-size: 22px;
    color: #ffffff;
    line-height: 15px;
    // text-align: left;
  }

  .dom_input {
    width: 308px;
    border: none;
    padding-left: 20px;
    height: 40px;
    background: #f6f6f6;
    border-radius: 7px;
  }
}

.bj_unit {
  margin-bottom: 123px;
  width: 100%;
  height: 560px;
  background: url("../../../static/newImg2/introduction_bg3.png");

  .bj_font {
    // height: 560px;
    text-align: center;
    line-height: 560px;
    font-family: 楷体;
    font-weight: 900;
    font-size: 72px;
    color: #ffffff;
    letter-spacing: 10px;
  }
}

.introduction {
  overflow: hidden;

  .introduction_about {
    width: 100%;
    height: 560px;
    background-image: url("../../../static/newImg2/contactUs_bg.png");
    background-repeat: no-repeat;
    background-size: cover;

    .introduction_about_box {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .introduction_about_name {
      font-weight: bold;
      font-size: 50px;
      color: #ffffff;
      letter-spacing: 18px;
      text-align: center;
      letter-spacing: 1px;
      line-height: 80px;
      font-family: 黑体;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .center_title {
    width: 1350px;
    margin: 0 auto;
    margin-top: 54px;

    .center_home {
      font-weight: 400;
      font-size: 16px;
      color: #1d1b19;
      vertical-align: top;
    }
  }

  .coontactUs {
    width: 1600px;
    margin: 0 auto;
    margin-top: 54px;

    .coontactUs_title {
      font-size: 48px;
      text-align: center;
      color: #000000;
      line-height: 54px;
    }

    .coontactUs_list {
      display: flex;
      justify-content: space-between;
      margin-top: 66px;

      .coontactUs_list_item {
        width: 30%;
        height: 240px;
        border: 1px solid rgba(208, 208, 208, 0.66);
        text-align: center;
        padding: 40px 0 0 0;

        & > img {
          border: 1px solid rgba(208, 208, 208, 0.66);
        }

        .coontactUs_list_item_img {
          color: #157b2f;
          font-size: 50px;
        }

        .coontactUs_list_item_title {
          font-size: 32px;
          color: #000000;
          line-height: 32px;
          margin-top: 10px;
        }

        .coontactUs_list_item_tips {
          font-size: 18px;
          color: #5b5d5f;
          line-height: 28px;
          margin-top: 20px;
        }

        .coontactUs_list_item_qrcode {
          font-size: 28px;
          color: #000000;
          line-height: 32px;
          margin-top: 20px;
        }
      }
    }
  }

  .business_list {
    display: flex;
    width: 1350px;
    margin: 0 auto;
    margin-top: 30px;

    .business_list_left {
      width: 240px;
      margin-right: 40px;

      .business_list_left_head {
        width: 240px;
        height: 64px;
        background: #18511c;
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        line-height: 64px;
        letter-spacing: 15px;
        text-align: center;
      }

      .business_list_left_tabList_tab {
        width: 240px;
        height: 64px;
        border-bottom: 1px solid #f5f5f7;
        border-left: 1px solid #f5f5f7;
        border-right: 1px solid #f5f5f7;
        line-height: 64px;
        text-align: center;
        cursor: pointer;
        position: relative;
      }

      .isActive {
        background: #f9f9f7;
      }

      .business_list_left_tabList_tab:hover {
        background: #f9f9f7;
      }

      .isActive::after {
        content: "";
        position: absolute;
        top: 25px;
        left: 170px;
        width: 0;
        height: 0;
        border: 7px solid transparent;
        /*以下四个样式对应四种三角形，任选其一即可实现*/
        border-left-color: #18511c;
      }
    }

    .business_list_right {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      cursor: pointer;

      .business_list_right_item {
        margin: 0 15px 15px 0;
        width: 300px;
        padding: 10px;
        border: 1px solid #00000011;
        border-radius: 5px;

        .business_list_right_item_img {
          width: 300px;
          height: 206px;
          overflow: hidden;

          img {
            transition: all 0.3s;
          }
        }

        .business_list_right_item_name {
          font-size: 18px;
          font-weight: 400;
          color: #252525;
          line-height: 25px;
          margin: 16px 0 10px 0;
        }

        .business_list_right_item_alias,
        .business_list_right_item_area {
          font-size: 14px;
          font-weight: 400;
          color: #858585;
          line-height: 23px;
          letter-spacing: 1px;
          overflow: hidden; // 溢出隐藏
          white-space: nowrap; // 强制一行
          text-overflow: ellipsis; // 文字溢出显示省略号
        }
      }

      .business_list_right_item:hover {
        .business_list_right_item_img img {
          transform: scale(1.1);
        }

        .business_list_right_item_name {
          color: #1e9409;
        }
      }

      .business_list_right_item:nth-child(4n) {
        margin-right: 0; // 去除第4n个的margin-right
      }
    }
  }

  .business_pagination {
    margin: 0 auto;
    margin-top: 16px;
    text-align: center;
    margin-bottom: 64px;
    width: 1350px;
  }
}

::v-deep .el-input__inner {
  border: none;
  width: 100px;
  background: #f6f6f6;
}

::v-deep .el-select {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
